export function useDocumentLink() {
  const { docsBase } = useRuntimeConfig().public
  return (path: string) => {
    if (!path) {
      return ''
    }
    return `${docsBase}${path}`
  }
}
